import { atom, swr } from '@exodus/headless-ui';
import prefillIdAtom from './prefill-id.js';
import prefillsAtom from './prefills.js';
const isSendAllAtom = atom((get) => {
    const prefillId = get(prefillIdAtom);
    const prefills = get(swr(prefillsAtom));
    return prefillId === 'max' && prefills.data?.max.label === 'ALL';
});
export default isSendAllAtom;
